<template>
  <FormKit type="select" label="Classification" v-model="modelValue" :options="classifications" />
</template>

<script lang="ts" setup>
import { useVModels } from '@vueuse/core';
const props = defineProps<{
  modelValue: string;
}>();
const classifications = ref([{ value: '', label: 'All' }, 'Sr', 'Jr', 'So', 'Fr']);
const emit = defineEmits(['update:modelValue']);
const { modelValue } = useVModels(props, emit);
</script>
